import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  useEffect(() => {
    // Carrega carrinho do localStorage
    const storedCart = localStorage.getItem('cart');
    if (storedCart) {
      setCart(JSON.parse(storedCart));
    }
  }, []);

  useEffect(() => {
    // Salva carrinho no localStorage
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (ebook) => {
    const exists = cart.find(item => item.id === ebook.id);
    if (!exists) {
      setCart([...cart, { ...ebook, quantity: 1 }]);
      return true;
    }
    return false;
  };

  const removeFromCart = (ebookId) => {
    setCart(cart.filter(item => item.id !== ebookId));
  };

  const clearCart = () => {
    setCart([]);
    localStorage.removeItem('cart');
  };

  const getTotal = () => {
    return cart.reduce((total, item) => total + item.price, 0);
  };

  const value = {
    cart,
    addToCart,
    removeFromCart,
    clearCart,
    getTotal,
    itemCount: cart.length
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};